export default __webpack_public_path__ + "static/media/hdfc.ee6e98b0.webp";